/**
 * Spoken-language catalog (English first, then A–Z by English label).
 * 39 codes. Scripts stay English; far-end hears DeepL then Fish.
 */

export interface SpokenLanguage {
  code: string;
  label: string;
}

export const SPOKEN_LANGUAGES: readonly SpokenLanguage[] = [
  { code: "en", label: "English" },
  { code: "sq", label: "Albanian" },
  { code: "ar", label: "Arabic" },
  { code: "bs", label: "Bosnian" },
  { code: "bg", label: "Bulgarian" },
  { code: "ca", label: "Catalan" },
  { code: "zh", label: "Chinese (Mandarin)" },
  { code: "hr", label: "Croatian" },
  { code: "cs", label: "Czech" },
  { code: "da", label: "Danish" },
  { code: "nl", label: "Dutch" },
  { code: "et", label: "Estonian" },
  { code: "fi", label: "Finnish" },
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "el", label: "Greek" },
  { code: "hu", label: "Hungarian" },
  { code: "is", label: "Icelandic" },
  { code: "it", label: "Italian" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "lv", label: "Latvian" },
  { code: "lt", label: "Lithuanian" },
  { code: "lb", label: "Luxembourgish" },
  { code: "mk", label: "Macedonian" },
  { code: "mt", label: "Maltese" },
  { code: "nb", label: "Norwegian (Bokmål)" },
  { code: "pl", label: "Polish" },
  { code: "pt", label: "Portuguese (Brazil)" },
  { code: "pt-pt", label: "Portuguese (Portugal)" },
  { code: "ro", label: "Romanian" },
  { code: "ru", label: "Russian" },
  { code: "sr", label: "Serbian" },
  { code: "sk", label: "Slovak" },
  { code: "sl", label: "Slovenian" },
  { code: "es", label: "Spanish" },
  { code: "sv", label: "Swedish" },
  { code: "tr", label: "Turkish" },
  { code: "uk", label: "Ukrainian" },
] as const;

export const LANGUAGE_CODES = SPOKEN_LANGUAGES.map((item) => item.code);

export const STAGE_FILES = [
  "identification.txt",
  "screening_response.txt",
  "send_code.txt",
  "enter_code.txt",
  "confirm_wait.txt",
  "retry.txt",
  "success.txt",
  "goodbye.txt",
] as const;

export type StageFile = (typeof STAGE_FILES)[number];
